class Render {
	constructor() {
		// Set up actions to return html
		this.data = [
			// {
			//     "class" : '.c-header__account',
			//     "wrapper" : '.c-header__account',
			//     "action" : 'account_state',
			// },
			{
				class: ".c-header__qty",
				wrapper: ".c-header__qty",
				action: "cart_count",
			},
			{
				class: ".c-messages__notice",
				wrapper: ".c-messages",
				action: "woo_messages",
			},
		];

		// Run the renderer
		this.runRender();
	}

	/**
	 * Run the render function
	 */
	runRender() {
		// Post request to the render API
		fetch("/api/render", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(this.data),
		})
			.then((response) => response.json())
			.then((data) => {
				data.forEach((element) => {
					const htmlWrapper = document.querySelectorAll(element.wrapper);

					if (htmlWrapper) {
						htmlWrapper.forEach((wrapper) => {
							// Check for the message wrapper
							const messageWrapper = wrapper.closest(element.class)
								? wrapper.closest(element.class)
								: wrapper.querySelector(element.class);

							// Reset
							wrapper.classList.remove("isHidden", "u-hide");

							// Check to see if need to hide element
							if (element.html == "hide") {
								wrapper.classList.add("isHidden", "u-hide");
							} else {
								// Remove Hidden Class
								wrapper.classList.remove("isHidden", "u-hide");

								// Set HTMl to render
								messageWrapper.innerHTML = element.html;

								// If WooCommerce hide after 5s
								if (element.action == "woo_messages") {
									setTimeout(() => {
										wrapper.classList.add("isHidden");
									}, 6000);
								}
							}
						});
					}
				});
			})
			.catch((error) => {
				console.log(error);
			});
	}
}

// Close for Woo Messages
const close = document.querySelector(".js-close-messages");

if (close) {
	close.addEventListener("click", () => {
		document.querySelector(".c-messages").classList.add("isHidden");
	});
}

// Re run render on update
window.addEventListener("load", () => {
	jQuery(document.body).on("updated_cart_totals", () => {
		new Render();
	});

	jQuery(".woocommerce-cart-form .remove").on("click", () => {
		setTimeout(() => {
			new Render();
		}, 250);
	});
});

// Export Render class (for ES6 modules)
export default Render;
